import { useEffect, useRef, useState } from 'react'
import { useSearchParams, Link } from 'react-router-dom'
import { apiClient } from '@/services/api/client'
import { extractErrorMessage } from '@/utils/errorHandler'

export function EngineerAcceptPage() {
  const [searchParams] = useSearchParams()
  const [status, setStatus] = useState<'verifying' | 'success' | 'error'>('verifying')
  const [message, setMessage] = useState('')
  const [email, setEmail] = useState('')
  const attemptedRef = useRef(false)

  useEffect(() => {
    const token = searchParams.get('token')

    if (!token) {
      setStatus('error')
      setMessage('Kein Einladungs-Token gefunden.')
      return
    }
    if (attemptedRef.current) return
    attemptedRef.current = true

    async function handleAccept() {
      try {
        const res = await apiClient.post(`/api/v1/auth/engineer/accept`, { token })
        setStatus('success')
        setMessage(res.data.message || 'Engineer-Rolle erfolgreich aktiviert.')
        setEmail(res.data.email || '')
      } catch (e) {
        setStatus('error')
        const errorMessage = extractErrorMessage(e, { loadError: 'Einladungs-Token ungültig oder abgelaufen.' })
        setMessage(errorMessage)
      }
    }

    handleAccept()
  }, [searchParams])

  if (status === 'verifying') {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="max-w-md w-full text-center py-8">
          <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-orange-600 mx-auto mb-4"></div>
          <p className="text-gray-600 text-lg">Einladung wird aktiviert...</p>
        </div>
      </div>
    )
  }

  if (status === 'success') {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="max-w-md w-full text-center py-8">
          <div className="text-green-500 text-6xl mb-4">✓</div>
          <h1 className="text-2xl font-bold text-gray-900 mb-2">Einladung aktiviert</h1>
          <p className="text-gray-600 mb-2">{message}</p>
          {email && <p className="text-sm text-gray-500 mb-6">E-Mail: {email}</p>}
          <p className="text-gray-600 mb-6">
            Sie können sich jetzt mit dieser E-Mail-Adresse einloggen.
          </p>
          <Link
            to="/login"
            className="inline-block bg-orange-600 text-white px-6 py-3 rounded-lg hover:bg-orange-700 transition-colors font-medium"
          >
            Jetzt einloggen
          </Link>
        </div>
      </div>
    )
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="max-w-md w-full text-center py-8">
        <div className="text-red-500 text-6xl mb-4">✗</div>
        <h1 className="text-2xl font-bold text-gray-900 mb-2">Aktivierung fehlgeschlagen</h1>
        <p className="text-gray-600 mb-6">{message}</p>
        <Link to="/login" className="text-blue-600 hover:text-blue-500 mt-4 inline-block">
          Zum Login
        </Link>
      </div>
    </div>
  )
}
